import {Component, ElementRef, Inject, LOCALE_ID, OnInit, ViewChild} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {User} from '../../model/auth/User';
import {ProgressRef, ProgressService} from '../../service/progress.service';
import {AuthService} from '../../service/auth.service';
import {NotificationHandler} from '../../helper/notification.handler';
import {Router} from '@angular/router';
import {UrlHelper} from '../../helper/url.helper';
import {UserService} from '../../service/user.service';
import {LocationService} from '../../service/location.service';
import {School, SchoolGrade} from '../../model/location/School';

@Component({
  selector: 'profile-school-details',
  templateUrl: './profile-school-details.component.html',
  styleUrls: ['./profile-school-details.component.scss']
})
export class ProfileSchoolDetailsComponent implements OnInit {

  user!: User | null;
  school!: School | null;
  grade?: SchoolGrade;

  dataLoadingProgress: ProgressRef | null | undefined;
  @ViewChild('progressContainer', {static: true}) progressContainer!: ElementRef;

  constructor(private progressService: ProgressService,
              private authService: AuthService,
              private userService: UserService,
              private locationService: LocationService,
              private router: Router,
              formBuilder: FormBuilder,
              @Inject(LOCALE_ID) locale: string) {
  }

  async ngOnInit() {
    await this.loadSchoolDetails();
  }

  private startProgress() {
    this.dataLoadingProgress = this.progressService.showProgress(this.progressContainer);
  }

  private stopProgress() {
    if (this.dataLoadingProgress) {
      this.progressService.detach(this.dataLoadingProgress);
      this.dataLoadingProgress = null;
    }
  }

  private async loadSchoolDetails() {
    this.startProgress();

    this.user = await this.authService.getUser();

    if (this.user && this.user.schoolId) {
      this.grade = this.user.schoolGrade;
      this.locationService.getSchoolDetails(this.user.schoolId).subscribe(school => {
        this.school = school;
      }, error => {
        this.school = null;
        NotificationHandler.handleError($localize`:Notifications|School details fetch has failed message@@notifications-school-details-fetch-failed-error:School details fetch has failed`, error);
      }, () => this.stopProgress());
    } else {
      this.school = null;
      this.stopProgress();
    }
  }

  async updateSchool() {
    await this.router.navigate([UrlHelper.SCHOOL_SELECT_PATH], {skipLocationChange: true});
  }

}
